import { DashboardCard } from "@dashboard/components/Card";
import { Text } from "@saleor/macaw-ui-next";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { orderCancelReasonCardMessages } from "./messages";

export interface OrderCancelReasonCardProps {
  /** From `getOrderCancelReason(order.metadata)`; `null` when the cancellation predates reasons. */
  reason: string | null;
}

/** Shown on cancelled orders only: the reason staff gave in the cancel dialog. */
export const OrderCancelReasonCard = ({ reason }: OrderCancelReasonCardProps) => {
  const intl = useIntl();

  return (
    <DashboardCard data-test-id="order-cancel-reason-card">
      <DashboardCard.Header>
        <DashboardCard.Title>
          {intl.formatMessage(orderCancelReasonCardMessages.title)}
        </DashboardCard.Title>
      </DashboardCard.Header>
      <DashboardCard.Content>
        {reason ? (
          <Text data-test-id="order-cancel-reason">{reason}</Text>
        ) : (
          <Text color="default2">
            <FormattedMessage {...orderCancelReasonCardMessages.noReason} />
          </Text>
        )}
      </DashboardCard.Content>
    </DashboardCard>
  );
};
